import { AuthConfig } from 'angular-oauth2-oidc';
import secret from '../apps/d2c-central/src/assets/json/environment.json';

const self = window.location.origin;
const primaveraBaseUrl = `${self}/login`;

// Partner token (vendor)
const partnerAuthConfig: AuthConfig = {
  issuer: 'https://partneridentity-pp.telus.com',
  loginUrl: 'https://partnerauth-it01.telus.com/am/oauth2/authorize',
  clientId: secret.d2cCentral.clientId, // The "Auth Code + PKCE" client
  dummyClientSecret: secret.d2cCentral.partner.secret,
  tokenEndpoint: self + '/token-proxy/as/token.oauth2',
  responseType: 'code',
  redirectUri: `${self}/login`,
  scope: '15 607 587 588 589 680 681 2242 openid', // Ask offline_access to support refresh token refreshes
  useSilentRefresh: false, // This refresh is for using an iframe and check the SSO session, is not needed for central
  sessionChecksEnabled: false,
  showDebugInformation: false, // Also requires enabling "Verbose" level in devtools
  clearHashAfterLogin: false, // https://github.com/manfredsteyerangular-oauth2-oidc/issues/457#issuecomment-431807040,
  oidc: true,
  disablePKCE: true,
  /*jwks: keys,*/
};

// Team Oauth
const teamAuthConfig: AuthConfig = Object.assign({}, partnerAuthConfig, {
  issuer: 'https://teamsso-its04.telus.com',
  clientId: secret.d2cCentral.clientId,
  dummyClientSecret: secret.d2cCentral.team.secret,
  loginUrl: 'https://teamsso-its04.telus.com/as/authorization.oauth2',
  tokenEndpoint: 'https://apigw-st.telus.com/st/token',
});

export const domains = {
  central: `${primaveraBaseUrl}/api`,
  proxy: 'https://d2c-api-proxy-np.cloudapps.telus.com',
  myWorld: `${primaveraBaseUrl}/myworld`,
  k2view: `${primaveraBaseUrl}/k2view`,
  ams: `${primaveraBaseUrl}/ams`,
  d2cGeo: `${primaveraBaseUrl}`,
};

export const environment = {
  environment: 'staging',
  appName: 'D2C_Central_Primavera_NaNe', // using for logout
  appDomain: '.d2c-central-partner-np.cloudapps.telus.com',
  appTeamDomain: '.d2c-central-team-np.cloudapps.telus.com',
  ptnrDomain: '.telus.com',
  redirectUri: `${self}/login`,
  kongLogoutURL:
    'https://partnerauth-it01.telus.com/am/XUI/?realm=/alpha&authIndexType=service&authIndexValue=Logout',
  kongLogoutTeamURL: 'https://teamsso-its04.telus.com/idp/startSLO.ping',
  production: false,
  enableStriker: true,
  oauth: {
    vendor: partnerAuthConfig,
    team: teamAuthConfig,
    headers: {
      vendor: { env: 'it01' },
    },
  },
  headers: {
    central: { env: 'it04' },
    k2view: { env: 'it04' },
    d2cGeo: { env: 'it04' },
    ams: { env: 'it04' },
    dsa: { env: 'it04' },
  },
  k2view: {
    itemsPerPage: 200,
  },
  baseUrl: self,
  domains,
  endpoints: {
    activity: `${domains.central}/marketsales/d2cActivity/v1/`,
    territoryManagement: `${domains.central}/marketsales/d2cTerritoryManagement/v1/`,
    appConfig: `${domains.central}/marketsales/d2cConfigMgmt/v1/`,
    iamserver: `${domains.central}/marketsales/d2cUserRolesPermissions/v1/`,
    reproster: `${domains.central}/marketsales/d2cUserRolesPermissions/v1/reproster/query/`,
    geoserver: `${domains.myWorld}/resource/myworldOGCWebServices/v1/telus/ows/`,
    k2view: `${domains.k2view}/common/k2viewConsolidatedData/v2/`,
    ams: `${domains.ams}/common/spatialnetAddressManagement/v2/`,
    d2cGeo: `${domains.d2cGeo}/d2cGeo/marketsales/d2cOGCWebServices/v1/`,
    dsa: `${domains.ams}/common/dsaD2CApi/v1/`,
  },
};
